import { render, staticRenderFns } from "./promise.vue?vue&type=template&id=478003f6"
import script from "./promise.vue?vue&type=script&lang=js"
export * from "./promise.vue?vue&type=script&lang=js"
import style0 from "./promise.vue?vue&type=style&index=0&id=478003f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports